import { render, staticRenderFns } from "./deliveryConfirms.vue?vue&type=template&id=50353409&scoped=true&"
import script from "./deliveryConfirms.vue?vue&type=script&lang=js&"
export * from "./deliveryConfirms.vue?vue&type=script&lang=js&"
import style0 from "./deliveryConfirms.vue?vue&type=style&index=0&id=50353409&lang=less&scoped=true&"
import style1 from "./deliveryConfirms.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50353409",
  null
  
)

component.options.__file = "deliveryConfirms.vue"
export default component.exports